import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';
import { TableCustomerOrder } from '@/components/sections/builder/elements/body/customer/customer_order/component/table';
import { CustomerOrderElementDataType } from '@/components/sections/builder/elements/body/customer/customer_order/type';
import { usePaginationSearchParams } from '@/hooks/use-pagination';
import React from 'react';
import FilterCustomerOrder from '@/components/sections/builder/elements/body/customer/customer_order/component/filter';

type OrderCustomerTabsProps = {
  content: CustomerOrderElementDataType;
  preview?: boolean;
};

const TAB_CONFIGS = [
  { value: 'all', label: 'All Orders' },
  {
    value: 'unpaid',
    label: 'Unpaid',
  },
  {
    value: 'processing',
    label: 'Processed',
  },
  {
    value: 'done',
    label: 'Done',
  },
  {
    value: 'cancel',
    label: 'Cancelled',
  },
];

export const OrderTabsCustomer = ({ preview, content }: OrderCustomerTabsProps) => {
  const [params, setParams] = usePaginationSearchParams();

  React.useEffect(() => {
    if (params.tab === 'total-stock') {
      setParams({ ...params, tab: 'all', pageIndex: 1, pageSize: 10 });
    }
  }, [params.tab]);

  return (
    <>
      <Tabs
        value={params.tab}
        className='relative h-full'
        onValueChange={(value) => {
          setParams({ ...params, tab: value, pageIndex: 1 });
        }}
      >
        <TabsList className='relative flex w-full flex-nowrap space-x-2 overflow-x-auto bg-transparent text-xs'>
          {TAB_CONFIGS.map((tab) => (
            <TabsTrigger
              key={tab.value}
              className={cn(`inline-flex flex-shrink-0 px-4 py-2 text-sm sm:text-base`)}
              style={
                params.tab === tab.value
                  ? {
                      color: content.colorScheme?.textSecondary,
                      borderBottomColor: content.colorScheme?.textSecondary,
                    }
                  : {}
              }
              isCustom
              value={tab.value}
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {TAB_CONFIGS.map((tab) => (
          <TabsContent key={tab.value} value={tab.value}>
            <FilterCustomerOrder tab={tab.value} params={params} setParams={setParams} />
            <TableCustomerOrder
              content={content}
              preview={preview as boolean}
              params={params}
              setParams={setParams}
            />
          </TabsContent>
        ))}
      </Tabs>
    </>
  );
};
